var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCompras(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9081 6.46787L15.4081 2.34287C15.2974 2.28195 15.173 2.25 15.0466 2.25C14.9202 2.25 14.7959 2.28195 14.6851 2.34287L7.18514 6.46787C7.06755 6.53261 6.96949 6.62773 6.9012 6.7433C6.8329 6.85886 6.79688 6.99064 6.79688 7.12487C6.79688 7.25911 6.8329 7.39088 6.9012 7.50645C6.96949 7.62201 7.06755 7.71713 7.18514 7.78187L14.2966 11.6931V19.7324L12.0196 18.4799L11.2966 19.7931L14.6851 21.6569C14.7958 21.7179 14.9202 21.75 15.0466 21.75C15.1731 21.75 15.2974 21.7179 15.4081 21.6569L22.9081 17.5319C23.0258 17.4672 23.1239 17.3721 23.1922 17.2565C23.2606 17.1409 23.2966 17.0091 23.2966 16.8749V7.12487C23.2966 6.99061 23.2606 6.85882 23.1922 6.74325C23.1239 6.62769 23.0258 6.53258 22.9081 6.46787ZM15.0466 3.85637L20.9904 7.12487L15.0466 10.3934L9.10289 7.12487L15.0466 3.85637ZM21.7966 16.4316L15.7966 19.7316V11.6924L21.7966 8.39237V16.4316Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29688 12H2.29688V10.5H8.29688V12ZM9.79688 18H3.79688V16.5H9.79688V18ZM11.2969 15H5.29688V13.5H11.2969V15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompras);
export default __webpack_public_path__ + "static/media/icon_compras.2d0f1ebcd3f8d8633d1847a3ea119bda.svg";
export { ForwardRef as ReactComponent };